// extracted by mini-css-extract-plugin
export default {"infoButton":"jlNOkxidfMaCUmSvXGwd","popoverContent":"GP_2LAfpmLvwefkcAZvU"};